import { getRetailUnitAndLanguage } from '../network/utils/getRetailUnitAndLanguage';
import { getEnv } from './env';
const { retailUnit } = getRetailUnitAndLanguage();

type Deployments = Partial<{
  [key: string]: (typeof env)[];
}>;

const RETAIL_UNITS_WITH_LOYALTY: Deployments = {
  lt: ['development', 'qa'],
  lv: ['development', 'qa'],
  ee: ['development', 'qa'],
};

const env = getEnv();

export const isLoyaltyEnabled = RETAIL_UNITS_WITH_LOYALTY?.[retailUnit]?.includes(env) ?? false;
